class StoryVideo extends HTMLElement {
  constructor() {
    super()


    this.modal = document.querySelector('.story-modal')
    this.close = document.querySelector('.story-modal__close')

    this.initialiseStoryVideo()
  }

  initialiseStoryVideo() {
    console.log('StoryVideo initialised')

    this.addEventListener('click', this.handleOpen)
    this.close.addEventListener('click', this.handleClose)
  }

  handleOpen(event) {
    console.log('StoryVideo clicked')
    this.modal.classList.add('story-modal__open')
    const video = document.querySelector('.story-vid__main');
    if (video) {
      video.play();
    }
  }

  handleClose() {
    console.log('StoryVideo closed')
    document.querySelector('.story-modal').classList.remove('story-modal__open')
    const video = document.querySelector('.story-vid__main');
    if (video) {
      video.pause();
    }
  }

}

customElements.define('story-video', StoryVideo)
